var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":_vm.itemRender.width,"label":_vm.itemRender.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }